import type { BadgeProps } from '@shared/ui';
import type { OrderStatus } from '../model/types';

const FORWARD_FLOW: OrderStatus[] = [
  'NEW',
  'IN_PROCESSING',
  'READY_TO_SHIP',
  'IN_TRANSIT',
  'AT_CUSTOMS',
  'DELIVERED',
];

const TERMINAL: OrderStatus[] = ['DELIVERED', 'CANCELLED'];

const TONE: Record<OrderStatus, NonNullable<BadgeProps['tone']>> = {
  NEW: 'info',
  IN_PROCESSING: 'warning',
  READY_TO_SHIP: 'primary',
  IN_TRANSIT: 'info',
  AT_CUSTOMS: 'warning',
  DELIVERED: 'success',
  CANCELLED: 'danger',
};

const LABEL: Record<OrderStatus, string> = {
  NEW: 'New',
  IN_PROCESSING: 'In processing',
  READY_TO_SHIP: 'Ready to ship',
  IN_TRANSIT: 'In transit',
  AT_CUSTOMS: 'At customs',
  DELIVERED: 'Delivered',
  CANCELLED: 'Cancelled',
};

export function orderStatusLabel(s: OrderStatus): string {
  return LABEL[s];
}

export function orderStatusTone(s: OrderStatus) {
  return TONE[s];
}

export function isTerminal(s: OrderStatus): boolean {
  return TERMINAL.includes(s);
}

export function nextForwardStatus(s: OrderStatus): OrderStatus | null {
  const idx = FORWARD_FLOW.indexOf(s);
  if (idx === -1) return null;
  return FORWARD_FLOW[idx + 1] ?? null;
}

export function canProducerCancel(s: OrderStatus): boolean {
  return s === 'NEW' || s === 'IN_PROCESSING' || s === 'READY_TO_SHIP';
}

export function allowedTransitions(s: OrderStatus): OrderStatus[] {
  if (isTerminal(s)) return [];
  const next = nextForwardStatus(s);
  const out: OrderStatus[] = [];
  if (next) out.push(next);
  if (canProducerCancel(s)) out.push('CANCELLED');
  return out;
}
